import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { inject, Injectable } from '@angular/core';
import { CoreService } from '../../../../core/services/core.service';
import { Observable, of, tap } from 'rxjs';
import { SystemValues } from '../../../../core/models/core.model';
import { DefendantState } from '../../states/defendant.state';

@Injectable({ providedIn: 'root' })
export class DefendantReferralResolver implements Resolve<Observable<SystemValues | null>> {

    //#region Injectables
    private state = inject(DefendantState);
    private coreService = inject(CoreService);
    //#endregion
    
    resolve(route: ActivatedRouteSnapshot): Observable<SystemValues | null> {
        const caseSequenceNumber = route.paramMap.get('sequeceNumber') || '0';
        const defendantId = route.queryParamMap.get('DefendantId') ?? '';

        if (!caseSequenceNumber) {
            return of(null);
        }
        return this.coreService.refereshSystemValues().pipe(
            tap(() => {
                this.state.setParameters(caseSequenceNumber, defendantId);
                // this.state.loadData();
            })
        );
    }
}
